import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdPaymentMethods() {
  return useQuery({
    queryKey: ['rd-payment-methods'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getPaymentMethods();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar as formas de pagamento do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
